var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlimFitWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-45,-90)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF",
      stroke: "#000000",
      strokeWidth: 1.87699997,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 82.845819,88.645478 -14.651776,5.517895 c 0,0 -26.030979,24.506847 -30.548566,28.565107 5.132178,7.58108 12.979618,17.45964 12.979618,17.45964 l 15.239804,-10.91465 c 0,0 4.228179,7.44639 4.228179,19.43232 0,11.98593 -4.228179,54.07332 -4.228179,54.07332 h 32.804544 0.740498 32.804539 c 0,0 -4.3031,-41.76778 -4.3031,-53.95934 0,-12.19156 4.3031,-19.5463 4.3031,-19.5463 l 15.2398,10.91465 c 0,0 7.84745,-9.87856 12.97962,-17.45964 -4.51758,-4.05826 -30.54857,-28.565107 -30.54857,-28.565107 L 115.23357,88.645478 H 99.409941 98.669443 Z",
    id: "path4496-3",
    clipPath: "none"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      stroke: "none",
      strokeWidth: 1.87732697,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 40.94497,119.69469 c -0.07578,0.0702 -0.17806,0.16549 -0.252068,0.23405 l 12.71184,18.14464 0.394576,-0.22791 C 53.144725,136.86756 43.414231,123.02467 40.94497,119.69469 Z",
    id: "path4496-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      stroke: "none",
      strokeWidth: 1.87732697,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    clipPath: "none",
    d: "m 156.95091,119.47098 c -2.0899,2.74118 -12.00602,16.80907 -12.92445,18.18092 l 0.39534,0.2283 12.76854,-18.18168 c -0.0727,-0.0688 -0.16512,-0.15712 -0.23943,-0.22754 z",
    id: "path4496-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1.98448944,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 82.845819,88.645478 c 0,11.776122 6.239633,20.199402 16.088991,20.155192 9.84936,-0.0442 16.19407,-7.75642 16.19407,-20.155192",
    id: "path4538-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.21035586,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 132.21448,129.80264 c 0,0 -4.00017,-15.19522 -3.93839,-21.74676 0.0617,-6.55154 1.60924,-13.892507 1.60924,-13.892507",
    id: "path4712"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 0.21035586,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 65.864899,129.80264 c 0,0 4.000172,-15.19522 3.938391,-21.74676 -0.06175,-6.55154 -1.609245,-13.892507 -1.609245,-13.892507",
    id: "path4712-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: "0.21002512px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 83.831597,90.729652 H 115.35385"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: "0.21002512px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 118.15582,89.749031 c 0,0 0.70264,21.713689 -18.913342,21.713689 -19.615981,0 -18.983401,-21.853775 -18.983401,-21.853775",
    id: "path4746"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlimFitWhite);
export default __webpack_public_path__ + "static/media/slim-fit-white.21eb8bce7189d5b7256e6e8709d6059f.svg";
export { ForwardRef as ReactComponent };